import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { useUser } from 'app/utils'

export function useAddMarketingColumns(): boolean {
  const me = useUser()
  const checkPermission = useCheckPermission()

  if (!me) return false
  return me.type === `super` || checkPermission(`org:marketing:advanced-filters`)
}
